export const servicesData = [
  {
    title: 'Remplacement d\'élevage/pension chiens - chats',
    description: 'Assurez le bien-être de vos animaux pendant votre absence.',
    image: 'remplacement-elevage.webp',
    link: 'remplacement-elevage'
  },
  {
    title: 'Bilan comportemental chiens - chats',
    description: 'Évaluez le comportement de vos animaux pour améliorer leur bien-être.',
    image: 'bilan-comportemental.webp',
    link: 'bilan-comportemental-chiens-chats'
  },
  {
    title: 'Cours d\'éducation',
    description: 'Apprenez à mieux comprendre votre chien grâce à des cours adaptés.',
    image: 'cours-educ.webp',
    link: 'cours-education-chiens-chats'
  },
    // {
    //   title: 'Pack adoption',
    //   description: 'Accompagnement personnalisé pour l\'adoption de votre nouveau compagnon.',
    //   image: '/img/services/pack-adoption.webp'
    // }
  ];